<template>
  <el-dialog
    :visible.sync="visible"
    :title="!dataForm.id ? $t('add') : $t('update')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <el-form-item label="模板名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="模板名称"></el-input>
      </el-form-item>
      <div class="w-full flex justify-end mb-4">
        <el-button
          size="mini"
          icon="el-icon-plus"
          @click="addRow()"
          type="primary"
          >增加原料</el-button
        >
      </div>
      <el-table :data="dataForm.detailList" border style="width: 100%">
        <el-table-column
          type="index"
          width="50"
          label="行号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column label="原料名称" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.name'"
              :rules="dataRule.name"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.name" placeholder="名称"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="颜色"
          prop="color"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.color'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.color" placeholder="颜色"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          label="规格"
          prop="size"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.size'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.size" placeholder="规格"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="幅宽" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.attr1'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.attr1" placeholder="幅宽"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="克重" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
              :prop="'detailList.' + scope.$index + '.attr2'"
              label-width="0"
              style="margin-top: 20px"
            >
              <el-input v-model="scope.row.attr2" placeholder="克重"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="数量" header-align="center" align="center">
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                label-width="0"
                :rules="dataRule.count"
                style="margin-top: 20px"
            >
              <el-input v-model="scope.row.count" placeholder="数量"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="100"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-remove"
              size="mini"
              @click="delRow(scope.$index, scope.row, 'detailList')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import { isNumber } from '@/utils/validate'
export default {
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {
        id: "",
        name: "",
        detailList: [],
      },
    };
  },
  computed: {
    dataRule() {
      return {
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "change",
          },
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if(!isNumber(value)){
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      };
    },
  },
  methods: {
    delRow(index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1);
      }
    },
    getNewRow() {
      return {
        name: "",
        code: "",
        color: "",
        size: "",
        attr1: "",
        attr2: "",
        count: "",
      };
    },
    addRow(dataKey) {
      if (!dataKey) {
        dataKey = "detailList";
      }
      this.dataForm[dataKey].push(this.getNewRow());
    },
    reset() {
      this.dataForm = {
        name: "",
        detailList: [],
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
        if (this.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/bom/template/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          if (res.data) {
            if (res.data.detailList) {
              res.data.detailList = JSON.parse(res.data.detailList);
            }
          }

          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
          console.log(this.dataForm)
        })
        .catch(() => {});
    },

    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let postForm = this.$clone(this.dataForm);
          postForm.detailList = JSON.stringify(postForm.detailList);
          this.$http[!postForm.id ? "post" : "put"](
            "/trade/bom/template/",
            postForm
          )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.cancel();
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    cancel() {
      this.visible = false;
    },
  },
};
</script>
